import { NgModule } from "@angular/core";
import { BpToggleGroupComponent } from "./bp-toggle-group.component";
import { CoreModule } from "@modules/core/core.module";

@NgModule({
	declarations: [BpToggleGroupComponent],
	exports: [BpToggleGroupComponent],
	imports: [CoreModule]
})
export class BpToggleGroup {}
